export class DatePickerModel {
  gregorian!: DateStruct;
  gregorianDate!: Date;
  hijri!: DateStruct;
  hijriDate!: Date;
  hijriDateText!: string;
}

export class DateStruct {
  day!: number;
  month!: number;
  year!: number;
  isHijri?: boolean;
}
